import { parseVendorSpecific } from "~/components/landings/utils";

export const VENDOR_SPECIFIC = parseVendorSpecific();
